import { EHolidayType, ProductZoneType, SeoPageType } from "../enums";
import { RouteStack } from "./base";

export const SeoEHolidayTypeMap: Record<
  EHolidayType,
  { holiday: SeoPageType; rank: SeoPageType }
> = {
  [EHolidayType.Spring]: {
    holiday: SeoPageType.Spring,
    rank: SeoPageType.SpringRank,
  },
  [EHolidayType.Easter]: {
    holiday: SeoPageType.Spring,
    rank: SeoPageType.SpringRank,
  },
};

export const SeoProductZoneTypeMap: Record<
  ProductZoneType,
  { zone: SeoPageType }
> = {
  [ProductZoneType.HighCommission]: {
    zone: SeoPageType.HighCommission,
  },
  [ProductZoneType.BestSelling]: {
    zone: SeoPageType.BestSelling,
  },
  [ProductZoneType.YouMayLike]: {
    zone: SeoPageType.YouMayLike,
  },
};

export const SeoPageUrlMap: Record<SeoPageType, string> = {
  [SeoPageType.Home]: RouteStack.Home,
  [SeoPageType.Product]: RouteStack.Product.product,
  [SeoPageType.PersonalCenter]: RouteStack.User.personalCenter,
  [SeoPageType.Christmas]: RouteStack.Christmas.activity,
  [SeoPageType.ChristmasDetail]: RouteStack.Christmas.detail,
  [SeoPageType.ChristmasRank]: RouteStack.Christmas.rank,
  [SeoPageType.Black5]: RouteStack.Black5.activity,
  [SeoPageType.Black5Rank]: RouteStack.Black5.rank,
  [SeoPageType.Winter]: RouteStack.Winter,
  [SeoPageType.HighCommission]: RouteStack.Recommended.highCommission,
  [SeoPageType.BestSelling]: RouteStack.Recommended.bestSelling,
  [SeoPageType.YouMayLike]: RouteStack.Recommended.youMayLike,
  [SeoPageType.Brand]: RouteStack.Brand,
  [SeoPageType.LowPrice]: RouteStack.LowPrice,
  [SeoPageType.Products]: RouteStack.Product.products,
  [SeoPageType.AboutUs]: RouteStack.AboutUs,
  [SeoPageType.CreatorPicks2025]: RouteStack.CreatorsPicks2025,
  [SeoPageType.Spring]: RouteStack.Spring.activity,
  [SeoPageType.SpringRank]: RouteStack.Spring.rank,
  [SeoPageType.Easter]: RouteStack.Easter.activity,
};
